import { useMutation } from "@tanstack/react-query";
import { downloadService } from "@/services/downloadService";

type UseFetchBlobUrlOptions = {
  onSuccess?: (blobUrl: string, revoke: () => void) => void;
  onError?: (error: Error) => void;
};

export const useFetchBlobUrl = (options?: UseFetchBlobUrlOptions) => {
  const mutation = useMutation({
    mutationFn: (url: string): Promise<string> =>
      downloadService.createBlobUrlFromFile(url),
    onSuccess: (blobUrl: string) => {
      const revoke = () => URL.revokeObjectURL(blobUrl);
      options?.onSuccess?.(blobUrl, revoke);
    },
    onError: (error: Error) => {
      console.error("Failed to fetch blob URL:", error);
      options?.onError?.(error);
    },
  });

  return {
    createBlobUrl: mutation.mutate,
    createBlobUrlAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error,
  };
};
